/*============= Blog Header Search in Mobile toggle =============*/
$('.search-icon').click(function(){
    $(this).parent('.search-overlay').toggleClass('active');
});
setTimeout(function () {
  if($("body .shipscout-banner").length){
   $("body").addClass("stickyTop-bar");
  }
}, 4000);

// faq section

$(".faq_question").click(function() {
    $(this).children(".arrow-svg").toggleClass("arrow-svg-rotate");
    $(this).next().slideToggle();
});

jsVariantopner();
function jsVariantopner(){
  if ($(".variant_items").length > 4) {
    $select = $(".variant_items");
    $(".variant_items").hide();
    for (let index = 0; index < 4; index++) {
        $select[index].style.display = "flex";
    }

    $(".variants-value").addClass("de-active");
    if ($(".variants-value").hasClass("de-active")) {
        $(".option_dropdown").click(function() {
          $(".js-variants-open").toggle();
          $(".down-arrow").toggleClass("arrow-svg-rotate")
      });
    }
  }
}

/*============= Desktop Menu On Hover code =J ============*/

let items = document.querySelector(".header__inline-menu")?.querySelectorAll("details");
items?.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
  });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    document.querySelector(".mega-menu__list").style.display = "grid";
    $('.product-grid-bar').removeClass('is-active')
    $('.categories_menu_link').removeClass('is-active')
    // document.querySelector(".categories_menu_link").classList.remove("is-active");
    
  });
});


/*============= Brand Mega Menu Search code =J ============*/

$('.brands_name_sorting .mega_brands_name_sorting_items').each(function() {
    var _this = $(this);
    _this.find(".sortings_items").on('mouseover click', function() { 
        var getParents = $(this).parents('.brands-mega-menu-desktop').length ? $(this).parents('.brands-mega-menu-desktop') : $(this).parents('.mobile-brands-mega-menu');
        $('.sortings_items').removeClass('is_active')
        $(this).addClass('is_active');
        var getS = $(this).text() == '#' ? 'hassign' :$(this).text();
        onBrandShort(getS, getParents)
    })
});

function onBrandShort(get, getParents) {
    $('.mega_brands_name_contents').scrollTop(0);
    $('.mega_brands_name_contents').scrollTop((getParents.find(`.sorted_name.list_${get}`).position().top - 90)); 

    // $('.mega_brands_name_contents').animate({
    //     scrollTop: $(`.mobile-brands-mega-menu .mega_brands_name_contents .sorted_name.list_${get}`).offset().top - $('.mega_brands_name_contents').offset().top + $('.mega_brands_name_contents').scrollTop()
    // }, 1000);
  
}

jQuery(".BrandSearchBox").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    jQuery(".mega_brands_name_contents ul,.mega_brands_name_contents ul *").filter(function() {
        $(this).not('.sorted_name, .sorted_name b').toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

/*============= Header Brand Mega Menu Tab Collection Image ============*/

$('.Collection_img').each(function(){
    const img = new Image();
      img.src = $(this).attr("src");
      img.onerror = () => $(this).hide();    
});

/*============= Header Brand Mega Menu Tabbing ============*/

$('.popular_brands_tabcontent .tab_names').on('mouseover', function() {
    var getTabName = $(this).data('tab');
    $('.popular_brands_tabcontent .tab_names').removeClass('is_active')
    $('.brands_wrapper').hide();
    $(this).addClass('is_active');
    $(`.brands_wrapper.${getTabName}`).show();
});

/*============= Header Categories Megamenu Code ============*/
$(document).ready(function(){  $('.categories_menu_link').hover(function(){ 
    $('.collections_images_wrapper .product-grid-bar').removeClass('is-active')
    $(this).addClass("is-active");    
    $(this).siblings().removeClass("is-active");
    var active = $(this).data("collection-handle");        
    $('#' + active).addClass("is-active");
    $('.mega-menu__list').css("display","none");  
    $('#' + active).siblings(".tabs__panel").removeClass("is-active");
  });
});



/*============= brand-list page ============*/

$('.brands_name_sorting .brands_name_sorting_items').each(function() {
    var _this = $(this);
    _this.find(".sortings_items").on('click', function() {
        $('.sortings_items').removeClass('is_active')
        $(this).addClass('is_active');
        var getS = $(this).text() == '#' ? 'hassign' :$(this).text();
        onSorting(getS);
    })
});

function onSorting(get) {
    $('.brand-collection .grid').scrollTop(0);
    var scrollPosition = $(`div.sorted_name.list_${get}`).next().position().top - 150;
    // console.log($(`.sorted_name.list_${get}`).next().position().top - 90);
    $('html, body').animate({
			scrollTop: scrollPosition
	}, 800);
}

/*============= Brand-List-slick slider code =============*/

$(document).ready(function() {
// Swiper: Slider
    new Swiper('.brand-list-slider.swiper-container', {
          loop: true,
          loopedSlides: 50,
          spaceBetween: 20,
          slidesPerView: 2,          
          paginationClickable: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          autoplay: {
        	  delay: 1500,
        	  disableOnInteraction: true,
          },
          breakpoints:{
                576:{
                slidesPerView:3,
                },
                850:{
                slidesPerView:4,
                },
                1024:{
                slidesPerView:5,
                },
                1360:{
                slidesPerView:5,
                },
            }
    });

  // Swiper: Slider
      new Swiper('.feature_collection:not(.recently-product) .swiper-container', {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          paginationClickable: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints:{
                480:{
                slidesPerView:2,
                },
                576:{
                slidesPerView:2,
                },
                850:{
                slidesPerView:3,
                },
                1024:{
                slidesPerView:4,
                },
                1360:{
                slidesPerView:5,
                },
            }
      });
  
// ============== Testimonial slider =================*/
  
  new Swiper('.testimonial-main-wrapper .slides', {
     		spaceBetween: 20,
            loop: true,
            grabcursor:true,
         	slidesPerView: 1,
            pagination: {
        		el: '.swiper-pagination',
        		clickable:true,
      		},  
    
            breakpoints:{
                576:{
                slidesPerView:2,
                },
                768:{
                slidesPerView:3,
                },
                1279:{
                slidesPerView:4,
                },
            }
         });

  // Goals Mobile Menu Slider

    if ($(window).width() < 989) {
    }
      new Swiper('.goals_mega_menu_inner_wrapper .swiper-container', {
              spaceBetween: 0,
              loop: true,
              grabcursor:true,
              slidesPerView: 2,
           });
  
  });


// --------------------- Mobile SubMenu SlideToggle J ------------------
$('#menu-drawer .menu-drawer__menu .detail-header__submenu .header__menu-item').click(function(){
    $(this).toggleClass('open');
    $(this).next('.header__submenu').slideToggle(400);
});

// ---------------- Mobile Menu Tab -J ------------------

$('.mobile-nav-tabs-menu a').on("click", function(){
    $(this).addClass('active-tab-menu');
    $('.mobile-nav-tabs-menu a').not($(this)).removeClass('active-tab-menu');

    var self = $(this).data('tab');
    $('.'+self).addClass('active');
    $('.mobile-nav-tabs').not($('.'+self)).removeClass('active');
});

/*============= Footer accordion & product tabbing mobile accordion =============*/
if($(window).width() < 750) {
  $(document).on('click', '.accordion_head', function(){
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").html('<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").html('<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve"><rect height="64" width="384" x="64" y="224"/></svg>');
    }
  });  
}

/*============= Product Tabbing =============*/
      
  $('#tabs-nav li').click(function(){
   if($(this).hasClass('active') == false){
     $('#tabs-nav li').removeClass('active');
   } 
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).toggle();
    return false;
  });

  $('.tab-content').hide();
  $('.tab-content:first').show();
  $('#tabs-nav li:first-child').addClass('active');
  $('#tabs-nav li:first-child').click();

/*============= Search to find tab // Faq page =============*/

jQuery("#searchInput").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    jQuery(".inner_text").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});


// document.querySelector('input').addEventListener('click', function(event) {
//   event.preventDefault();
// });


// Blog Date

const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });

  $('.date span').append(formattedDate);
  
  console.log(formattedDate); // "Friday, May 12"

// Blog Social icon Show - hide

$(".show-more").click(function(e){
    e.preventDefault();
    $(this).hide()
    $(this).closest(".social_icons_wrapper").find(".blog_social_links").removeClass("icon_show")
})

// estimated delivery date
    
function calculateEstimatedDelivery() {
  const cutOffTime = 12; 

  const currentDate = new Date();
  const currentDayOfWeek = currentDate.getDay(); 
  const currentHour = currentDate.getHours();
  
  if (currentDayOfWeek >= 1 && currentDayOfWeek <= 5 && currentHour < cutOffTime) {
    dispatchDate = new Date(currentDate);
  } else {
    dispatchDate = new Date(currentDate);
    dispatchDate.setDate(dispatchDate.getDate() + (1 + 5 - currentDayOfWeek) % 5); 
  }
  
  const deliveryStartDate = new Date(dispatchDate);
  deliveryStartDate.setDate(dispatchDate.getDate() + 3); 
  
  if(deliveryStartDate.getDay() == 6){
    deliveryStartDate.setDate(deliveryStartDate.getDate() + 2); 
  }else if(deliveryStartDate.getDay() == 0){
    deliveryStartDate.setDate(deliveryStartDate.getDate() + 1); 
  }
  
  const deliveryEndDate = new Date(deliveryStartDate);
  // console.log("deliveryEndDate",deliveryEndDate);
  deliveryEndDate.setDate(deliveryEndDate.getDate() + 3); 
  // console.log("deliveryEndDate",deliveryEndDate);
  if(deliveryEndDate.getDay() == 6){
    deliveryEndDate.setDate(deliveryEndDate.getDate() + 2);  
  }else if(deliveryEndDate.getDay() == 0){
    deliveryEndDate.setDate(deliveryEndDate.getDate() + 1); 
  }

  const deliveryStartString = deliveryStartDate.toDateString().slice(4, 10);
  const deliveryEndString = deliveryEndDate.toDateString().slice(4, 10);
  return `${deliveryStartString} - ${deliveryEndString}`;
}
if(document.getElementById('estimated-delivery')){
 document.getElementById('estimated-delivery').innerHTML = calculateEstimatedDelivery();
}